import { EPermission } from '@/enums/EPermission';
import { EUserRole } from '@/enums/EUserRole';
import { IMenuItem } from '@/interfaces/menuItem';

export const mainMenu: IMenuItem[] = [
  {
    key: 'dashboard',
    name: 'Dashboard',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
      EUserRole.Observe,
    ],
  },
  {
    name: 'ออเดอร์',
    key: 'order',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
      EUserRole.Observe,
    ],
  },
  {
    name: 'Export',
    key: 'export',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
      EUserRole.Observe,
    ],
  },
  {
    name: 'ลูกค้า',
    key: 'customer',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
  {
    name: 'สินค้า',
    key: 'product',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
      EUserRole.Warehouse,
    ],
  },
  {
    name: 'สต็อก',
    key: 'stock',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
  {
    name: 'Stock Report',
    key: 'stock-report',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Sales Report',
    key: 'sales-report',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Sales Report',
    key: 'sales-report-2',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  // {
  //   name: 'Collector Report',
  //   key: 'collector-report',
  //   permission: EPermission.Allow,
  //   roles: [
  //     EUserRole.Admin,
  //     EUserRole.Manager,
  //     EUserRole.SuperAdmin,
  //     EUserRole.Employee,
  //     EUserRole.Collector,
  //   ],
  // },
  {
    name: 'Customer Order Report',
    key: 'customer-order-report',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'ข้อมูลบริษัท',
    key: 'company',
    permission: EPermission.Allow,
    roles: [EUserRole.Manager, EUserRole.SuperAdmin],
  },
  {
    name: 'Business Unit',
    key: 'bu',
    permission: EPermission.Allow,
    roles: [EUserRole.Manager, EUserRole.SuperAdmin],
  },
  {
    name: 'หน่วย',
    key: 'base-unit',
    permission: EPermission.Allow,
    roles: [EUserRole.Manager, EUserRole.SuperAdmin],
  },
  {
    name: 'Email Follow Up',
    key: 'email-follow-up',
    permission: EPermission.Allow,
    roles: [EUserRole.Manager, EUserRole.SuperAdmin],
  },
  {
    name: 'ผู้ใช้งาน',
    key: 'user',
    permission: EPermission.Allow,
    roles: [EUserRole.Manager, EUserRole.SuperAdmin],
  },
  // {
  //   name: 'Collector',
  //   key: 'collector',
  //   permission: EPermission.Allow,
  //   roles: [EUserRole.Manager, EUserRole.SuperAdmin, EUserRole.Collector],
  // },
  {
    name: 'Inbound',
    key: 'inbound',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Return',
    key: 'return',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Credit Debit Note',
    key: 'cndn-note',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Billing Note',
    key: 'billing-note',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Free Form',
    key: 'free-form',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Free Form',
    key: 'cndn-free-form',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Free Form',
    key: 'order-free-form',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'Location',
    key: 'location',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
      EUserRole.Observe,
    ],
  },
];

export const transportMenu: IMenuItem[] = [
  {
    key: 'location',
    name: 'จุดรับ - ส่ง',
    permission: EPermission.LocationView,
  },
  {
    key: 'route',
    name: 'ตั้งค่าเส้นทาง',
    permission: EPermission.RouteView,
  },
];

export const settingMenu: IMenuItem[] = [
  {
    key: 'company',
    name: 'ข้อมูลบริษัท',
    permission: EPermission.Allow,
  },
  {
    key: 'business-unit',
    name: 'Business Unit',
    permission: EPermission.Allow,
  },
  {
    key: 'unit-setting',
    name: 'หน่วย',
    permission: EPermission.Allow,
  },
  {
    key: 'user',
    name: 'ผู้ใช้งาน',
    permission: EPermission.Allow,
  },
  {
    key: 'exchange-rate',
    name: 'Exchange Rate',
    permission: EPermission.Allow,
  },
  {
    name: 'Email Follow Up',
    key: 'email-follow-up',
    permission: EPermission.Allow,
    roles: [EUserRole.Manager, EUserRole.SuperAdmin],
  },
];

export const worklogMenu: IMenuItem[] = [
  {
    key: 'worklog',
    name: 'ลงชื่อเข้าทำงาน',
    permission: EPermission.WorklogView,
  },
  {
    key: 'worklog-history',
    name: 'ประวัติย้อนหลัง',
    permission: EPermission.WorklogView,
  },
  {
    key: 'worklog-report',
    name: 'รายงานสรุปการเข้างาน',
    permission: EPermission.WorklogReport,
  },
];

export const driverMenu: IMenuItem[] = [
  {
    key: 'driver',
    name: 'คนขับรถ',
    permission: EPermission.DriverView,
  },
  {
    key: 'driver-group',
    name: 'กลุ่มคนขับ',
    permission: EPermission.DriverView,
  },
];

export const StockMenu: IMenuItem[] = [
  {
    key: 'stock',
    name: 'วัตถุดิบทั้งหมด',
    permission: EPermission.StockView,
  },
  {
    key: 'setting-product-group',
    name: 'กลุ่มวัตถุดิบ',
    permission: EPermission.StockView,
  },
  {
    key: 'stock-unit',
    name: 'หน่วยวัตถุดิบ',
    permission: EPermission.StockView,
  },
];

export const OrderMenu: IMenuItem[] = [
  {
    key: 'order',
    name: 'ออเดอร์',
    permission: EPermission.StockView,
  },
  {
    key: 'reserved',
    name: 'จองสินค้า',
    permission: EPermission.StockView,
  },
];

export const InboundMenu: IMenuItem[] = [
  {
    key: 'inbound',
    name: 'Inbound',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
  {
    key: 'gr',
    name: 'Good Received',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
  {
    key: 'financial-report',
    name: 'Financial Report',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
  {
    key: 'note-purchase',
    name: 'Note Purchase',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
];

export const ReturnMenu: IMenuItem[] = [
  {
    key: 'return',
    name: 'Return',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
];

export const ReportMenu: IMenuItem[] = [
  {
    key: 'sales-report-2',
    name: 'Sales Report',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    key: 'stock-report',
    name: 'Safety Stock Report',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    key: 'customer-order-report',
    name: 'Customer Order Report',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    key: 'tax-report',
    name: 'Tax Invoice Report',
    permission: EPermission.Allow,
    roles: [EUserRole.Admin, EUserRole.Manager, EUserRole.SuperAdmin],
  },
];

export const ProductMenu: IMenuItem[] = [
  {
    key: 'product',
    name: 'Product',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Warehouse,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
  {
    key: 'product-allocations',
    name: 'Product Allocations',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
      EUserRole.Warehouse,
    ],
  },
  {
    key: 'product-allocations-files',
    name: 'Files History',
    permission: EPermission.StockView,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.Employee,
      EUserRole.SuperAdmin,
    ],
  },
];

export const FreeFormMenu: IMenuItem[] = [
  {
    name: 'ใบแจ้งหนี้',
    key: 'order-free-form',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
  {
    name: 'ใบลดหนี้/เพิ่มหนี้',
    key: 'cndn-free-form',
    permission: EPermission.Allow,
    roles: [
      EUserRole.Admin,
      EUserRole.Manager,
      EUserRole.SuperAdmin,
      EUserRole.Employee,
    ],
  },
];
